<template>
  <div class="l-header-container" :class="[scrollTop > 563 ? 'l-header-container--bg' : '']">
    <img class="c-header__logo" src="../../../common/image/logo.png" alt="" srcset="">
    <div class="c-navbars">
      <router-link to="/">
        <nav class="c-navbar" :class="[$route.name === 'Index' ? 'c-navbar--active' : '']">首页</nav>
      </router-link>
      <router-link to="/projects">
        <nav class="c-navbar" :class="[$route.name === 'Project' ? 'c-navbar--active' : '']">案例</nav>
      </router-link>
      <nav class="c-navbar">关于</nav>
      <nav class="c-navbar">沟通</nav>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    scrollTop: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      currentTab: 'Index'
    };
  },
  computed: {},
  methods: {
    go(routerName) {
      this.$router.push({ name: routerName });
    }
  }
};
</script>
<style lang="scss">
@import '~common/scss/mixin';
.l-header-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 90px;
  z-index: 999;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 19%;
  background: transparent;
  transition: all 0.4s linear;
  &.l-header-container--bg {
    background: rgba(51, 134, 255, 1);
    transition: all 1s linear;
  }
  .c-header__logo {
    width: 30px;
    height: 30px;
    vertical-align: middle;
  }
  .c-navbars {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .c-navbar {
    font-size: 16px;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.6);
    line-height: 22px;
    margin-left: 55px;
    cursor: pointer;
  }
  .c-navbar--active {
    color: rgba(255, 255, 255, 1);
  }
}
</style>
